var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2827 7.46161C17.58 7.17324 18.0549 7.18051 18.3432 7.47785L20.5384 9.74127C20.7484 9.95779 20.8082 10.279 20.6903 10.5567C20.5724 10.8343 20.2996 11.0142 19.998 11.0134L12.8478 10.9941C12.8474 10.9941 12.8471 10.9941 12.8468 10.9941C10.1014 10.9946 7.75 13.4391 7.75 16.5506C7.75 18.0916 8.33437 19.486 9.2675 20.4892C9.54961 20.7925 9.53242 21.2671 9.22912 21.5492C8.92582 21.8313 8.45126 21.8141 8.16915 21.5108C6.9791 20.2313 6.25 18.4724 6.25 16.5506C6.25 12.7176 9.17008 9.49405 12.8478 9.49405H12.8498L18.2232 9.50861L17.2665 8.52215C16.9781 8.22481 16.9853 7.74999 17.2827 7.46161Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.598 11.4917C22.8787 11.1872 23.3532 11.1678 23.6578 11.4485C24.9405 12.6305 25.75 14.2802 25.75 16.1071C25.75 19.7818 22.5182 22.6786 18.7025 22.6786L18.7007 22.6786L12.9864 22.6653L13.8607 23.438C14.1711 23.7123 14.2003 24.1863 13.926 24.4967C13.6517 24.807 13.1777 24.8363 12.8674 24.562L10.5034 22.4727C10.2695 22.266 10.1881 21.9361 10.2989 21.6443C10.4098 21.3526 10.6897 21.16 11.0018 21.1607L18.7025 21.1786C18.7028 21.1786 18.703 21.1786 18.7033 21.1786C21.8048 21.1781 24.25 18.8429 24.25 16.1071C24.25 14.7376 23.6451 13.4766 22.6413 12.5515C22.3367 12.2708 22.3173 11.7963 22.598 11.4917Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 16C13.25 15.5858 13.5858 15.25 14 15.25H18C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H14C13.5858 16.75 13.25 16.4142 13.25 16Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshare);
export default __webpack_public_path__ + "static/media/reshare.d151c406.svg";
export { ForwardRef as ReactComponent };